

export const GET_COMPANIES_QUERY = `
  query GetCompanies($where: companies_bool_exp = {}, $limit: Int, $offset: Int, $order_by: [companies_order_by!] = [{ created_at: desc }]) {
    companies_aggregate(where: $where) {
      aggregate { count }
    }
    companies(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      name
      email_address_of_representative
      name_of_representative_
      phone_of_representative
      created_at
      updated_at
    }
  }
`;